

const routes = [
    {
        path: '/',
        redirect:'/home'
    },
    {
        path: '/home',
        name: 'Home',
        meta: {
            title: "出行集能量"
        },
        component: ()=>import('@/views/Home')
    },
    {
        path: '/invite',
        name: 'Invition',
        meta: {
            title:'百万能量'
        },
        component: ()=>import('../views/invite')
    },
    {
      path: '/userInfo',
        name: 'userFortuneCoin',
        meta: {
          title:'我的能量'
        },
        component: ()=>import('../views/user-fortune-coin')
    },
    {
        path: '/exchange',
        name: 'Exchange',
        meta: {
            title: '兑换列表'
        },
        component: ()=>import('@/views/exchange')
    },
    {
        path: '/activationCode',
        name: 'activationCode',
        meta: {
            title: '兑换细则'
        },
        component: ()=>import('@/views/exchange/pages/activationCode')
    },
    {
        path: '/about',
        name: 'About',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
    }
]
export default routes